const REDACT_TYPE_OPTIONS = {
  AI: 'ai',
  KEYWORDS: 'keywords',
  ZONE: 'zone',
} as const

type TemplateType = (typeof REDACT_TYPE_OPTIONS)[keyof typeof REDACT_TYPE_OPTIONS]

export { type TemplateType, REDACT_TYPE_OPTIONS }
